/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
//import VeeValidate, { Validator } from 'vee-validate';

require('./bootstrap');

require('bootstrap-select/js/bootstrap-select');

window.Vue = require('vue');
//window.VeeValidate = VeeValidate;

window.moment = require('moment/moment.js');

//Vue.use(VeeValidate);


require('jquery-ui-dist/jquery-ui.min.js');

require('../../public/js/owl.carousel.min');

require('daterangepicker/daterangepicker');

require('./../../public/js/main.js');
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.directive('alphanumeric', {
    bind(el) {
        el.addEventListener('input', () => {
            const originalValue = el.value;
            const newValue = originalValue.replace(/[^a-zA-Z0-9]/g, '');
            if(originalValue !== newValue) {
                el.value = newValue;
                el.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });
    }
});

Vue.directive('alphanumeric-uppercase', {
    bind(el) {
        el.addEventListener('input', () => {
            const originalValue = el.value;
            const newValue = originalValue.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
            if(originalValue !== newValue) {
                el.value = newValue;
                el.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });
    }
});

Vue.directive('alphanumeric-space', {
    bind(el) {
        el.addEventListener('input', () => {
            const originalValue = el.value;
            const newValue = originalValue.replace(/[^a-zA-Z0-9 ]/g, '');
            if(originalValue !== newValue) {
                el.value = newValue;
                el.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });
    }
});

Vue.directive('alphanumeric-space-dash', {
    bind(el) {
        el.addEventListener('input', () => {
            const originalValue = el.value;
            const newValue = originalValue.replace(/[^a-zA-Z0-9 \-]/g, '');
            if(originalValue !== newValue) {
                el.value = newValue;
                el.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });
    }
});

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('home-search', require('./components/HomeSearch.vue').default);
Vue.component('booking-details', require('./components/BookingDetails.vue').default);
Vue.component('input-company-select-search', require('./components/input/CompanySelectSearch.vue').default);
Vue.component('login-form-component', require('./components/LoginFormComponent.vue').default);
Vue.component('ens', require('./components/Ens.vue').default);



//Vue.mixin(require('./components/trans'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
